module.exports = __webpack_public_path__ + "static/matt-joseph-lg-370e4758232c74e21fbda5d7c390afa8.png";